<div class="forgot-password-area">
    <div class="d-table">
        <div class="d-table-cell">
            <div
                class="daxa-form ml-auto mr-auto border-radius bg-white"
                [class.card-borderd-theme]="themeService.isCardBorder()"
            >
                <div class="title text-center">
                    <h3>
                        Zaboravili ste lozinku?
                    </h3>
                    <p class="ml-auto mr-auto">
                        Unesite adresu e-pošte koju ste koristili prilikom registracije i poslat ćemo vam upute za ponovno postavljanje lozinke.
                    </p>
                </div>
                <form>
                    <div class="form-group">
                        <label class="main-label d-block lh-1 text-black">
                            Adresa elektroničke pošte
                        </label>
                        <mat-form-field>
                            <mat-label>
                                Unesite adresu elektroničke pošte
                            </mat-label>
                            <input matInput type="email">
                        </mat-form-field>
                    </div>
                    <button mat-button class="btn" type="submit">
                        Pošalji
                    </button>
                    <div class="text-center back-to-sign-in">
                        <a mat-button routerLink="/authentication">
                            <i class="ri-arrow-left-s-line"></i>
                            Nazad na prijavu
                        </a>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>